
//import {Vue} from "vue-property-decorator";
//import Component from "vue-class-component";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Alert } from "@/addons/Alert";
//import { http } from "@/config/HttpClient";
import { DateTime } from "luxon";
import { useConsultorioStore } from '../../store/consultorioStore';
import { globalStore } from '../../store/globalStore';
import { consultorioService } from '../../services/ConsultorioService';

@Component({
  name: "NuevoTratamiento",
})

export default class NuevoTratamiento extends Vue {
  @Prop() tratamientoEdit!: any
  @Prop() dialog!: boolean
  @Prop() swEditar!: boolean

  private globalStore = globalStore();
  private consultorioStore = useConsultorioStore();
  private consultorioService = consultorioService.getInstance();
  private tab: any = null;

  cliente_seleccionado = '';
  pacientes_all = [];

  tratamiento = {
    nombre: '',
    descripcion: '',
    costo: 0,
    tiempo_duracion: '',
    color: '',
  }
  valid = true;
  fecha = DateTime.now().toFormat('yyyy-MM-dd');
  get especialidades(): any {
    return this.consultorioStore.especialidades;
  }
  mounted() {
    //this.consultorioService.getEspecialidades();
  }
  close() {
    this.$emit('close');
  }
  guardar() {
    if (!this.$refs.form.validate()) {
      Alert.warning(`Lene todos los campos obligatorios (*)`)
      return;
    }
    if (!this.swEditar) {
      Alert.confirm(`Se realizará el registro del tratamiento ${this.tratamiento.nombre}`, 'Registrar nueva Tratamiento?').then(async result => {
        if (result.isConfirmed) {
          await this.consultorioService.registrarTratamiento(this.tratamiento).then(response => {

            this.limpiar()
            this.close()
            this.$emit('listar');
          })

        }
      })
    } else {
      Alert.confirm(`Se realizará la modificacion de la venta`, 'Modificar venta?').then(async result => {
        if (result.isConfirmed) {
          await this.consultorioService.editarVenta(this.venta)
          this.limpiar()
        }
      })
    }

  }
  
  
  limpiar() {
    this.tratamiento = {
      nombre: '',
      descripcion: '',
      costo: 0,
      tiempo_duracion: '',
      color: '',
    }
  }
  get loading(): boolean {
    return this.consultorioStore.loading;
  }
  @Watch('txtSearch')
  search(value: string) {
    console.log(value);
    if (value != null && value.length > 2) {
      this.$nextTick().then(() => {
        this.getPacientesSearch(value);
      })

      this.pacientes_all = this.consultorioStore.pacientes;
      console.log(this.pacientes_all);
    }



  }
}

